import { EventEmitter, Injectable, Output } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { PopInfoDto } from '../dto/Validators/PopInfoDto';
import { PopValidatorDto } from '../dto/Validators/PopValidatorDto';
import { FillFormService } from '../services/fill-form.service';

@Injectable({
  providedIn: 'root'
})
export class PopAsyncValidator implements AsyncValidator {

  constructor(
    private fillFormService: FillFormService
  ) { }

  @Output() popInfoEvent: EventEmitter<PopValidatorDto> = new EventEmitter<PopValidatorDto>();
  private regex = /(CZ\/)?\d{1,3}\/\d{1,4}\/\d{4}/g;

  validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    if (control.value != void 0 && control.value.match(this.regex)?.length > 0) {
      return this.fillFormService.getPopInfo(control.value)
        .pipe(
          map(resp => {
            if (resp == void 0 || !resp.success) {
              this.popInfoEvent.emit({ data: null, control: control, popInfo: null });
              return { 'popError': 'POP nebylo nalezeno.' };
            }
            else {
              let popInfoDto: PopInfoDto = new PopInfoDto();
              popInfoDto.cisloPop = control.value;
              popInfoDto.druhRm = resp.data.druhRepMaterialu;
              popInfoDto.rokZrani = resp.data.rokZrani;
              popInfoDto.dodavatelId = resp.data.dodavatelId;
              this.popInfoEvent.emit({ data: resp.data, control: control, popInfo: popInfoDto });
              return null;
            }
          })
        );
    }
    else {
      this.popInfoEvent.emit({ data: null, control: control, popInfo: null });
      return of({ 'popError': 'POP není validní.' });
    }
  }
}
